import { throttle, debounce } from 'throttle-debounce'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import gsap from 'gsap';
import Lenis from 'lenis'
gsap.registerPlugin(ScrollTrigger)

export default class ScrollManager {
  constructor() {

    this.bindMethods()

    this.getElems()
    this.initScroll()

    this.events();

  }

  bindMethods() {
    this.scroll = this.scroll.bind(this)
    this.scroll = throttle(200, this.scroll)
    this.initScroll = this.initScroll.bind(this)
    this.render = this.render.bind(this)
  }

  events() {

    this.lenis.on('scroll', this.scroll)
  }

  getElems() {
    this.domWrapper = document.querySelector('.wrapper')
    this.domScroll = document.querySelector('.content-scroll')
  }

  scroll(e) {
    ScrollTrigger.update()
  }

  initScroll() {
    this.lenis = new Lenis({
      duration: 2.4,
      wrapper: this.domWrapper,
      content: this.domScroll,
    })

    this.lenis.stop();

    ScrollManager.lenis = this.lenis


    this.initScrollTrigger(this.domWrapper)
  }

  start() {
    this.lenis.start()
  }

  initScrollTrigger(scrollContainer) {
    ScrollTrigger.defaults({
      scrub: true, scroller: scrollContainer
    })
  }

  render(elapsedMs) {
    this.lenis.raf(elapsedMs)
  }
}
